import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase';
import { REPORT_CALLABLE } from './reportContract';
import { CONVERSION_REPORT_ACTION, type ConversionReportResult } from './conversionContract';

/**
 * Stage-to-stage conversion, followed deal by deal across every published snapshot.
 *
 * Takes no period, like stage movement: the history is exactly as long as the run of uploads, and
 * the section says how long that is rather than pretending to fit the page's window.
 */
export function useConversionReport(companyId: string) {
  const [result, setResult] = useState<ConversionReportResult | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setResult(null);
    setError(null);
    if (!companyId) {
      setLoading(false);
      return () => { cancelled = true; };
    }
    const call = httpsCallable(functions, REPORT_CALLABLE);
    void call({ action: CONVERSION_REPORT_ACTION, companyId }).then((response) => {
      if (!cancelled) setResult(response.data as ConversionReportResult);
    }).catch(() => {
      if (!cancelled) setError('Stage-to-stage conversion could not be loaded.');
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, [companyId]);
  return { result, loading, error };
}
